import { render, staticRenderFns } from "./ValidasiKedatanganTruckDetail.vue?vue&type=template&id=7f6638a5&scoped=true"
import script from "./ValidasiKedatanganTruckDetail.vue?vue&type=script&lang=js"
export * from "./ValidasiKedatanganTruckDetail.vue?vue&type=script&lang=js"
import style0 from "./ValidasiKedatanganTruckDetail.vue?vue&type=style&index=0&id=7f6638a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6638a5",
  null
  
)

export default component.exports